import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const ArchiveUser = ({ isOpen, onClose, onConfirm, firstName, lastName }) => {
    const bodyMessage = `Are you sure you want to archive <strong>${firstName} ${lastName}</strong>'s profile? This action cannot be undone.`;

    return (
        <ReusableModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Confirm Archive"
            bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
            confirmLabel="Confirm"
            cancelLabel="Cancel"
        />
    );
};

export default ArchiveUser;
